// extracted by mini-css-extract-plugin
module.exports = {"hentry":"StaticPage_hentry__tEUYz","btn":"StaticPage_btn__HWkcI","slCamEmbed":"StaticPage_slCamEmbed___nDai"};